import { get } from 'lodash';
import { RegionType } from '@wix/shoutout-email-model-v3';
import { injectMissingPropsIntoHtml } from '../../utils/inject-missing-props-into-html';
import { wrapWithElement } from '../../utils/wrap-with-element';
import { defaultLineHeight, defaultTextColor, defaultTextSize, } from '../../utils/defaults';
import { getRegionMobileCssClass, prop, textAlign, margin as getMargin, padding as getPadding, } from '../../utils/css-utils';
export const getTextSection = ({ composerData, css, experiments, region, isRtl, manipulateHtml, }) => {
    if (region.type !== RegionType.Text) {
        throw Error('Text must be passed');
    }
    const isTitle = region.fixed;
    const userOverrides = get(region, 'data.styles.region', {});
    const rules = isTitle
        ? [
            userOverrides,
            css['so-global-title'],
            css['so-global-region-title'],
            css['so-global-region'],
        ]
        : [
            userOverrides,
            css['so-global-p1'],
            css['so-global-text'],
            css['so-global-region-text'],
            css['so-global-region'],
        ];
    const cssClass = isTitle ? 'so-global-title' : 'so-global-p1';
    const html = manipulateHtml
        ? injectMissingPropsIntoHtml(wrapWithElement(region.data.html, 'div', cssClass), {
            lineHeight: defaultLineHeight,
            fontSize: prop('fontSize')(rules) || defaultTextSize,
        }, composerData, css, experiments, true)
        : wrapWithElement(region.data.html, 'div', cssClass);
    const borderWidth = prop('borderWidth')(rules) || 0;
    const borderStyle = prop('borderStyle')(rules) || 'none';
    const borderColor = prop('borderColor')(rules) || 'transparent';
    const text = {
        backgroundColor: prop('backgroundColor')(rules) || 'transparent',
        border: `${borderWidth} ${borderStyle} ${borderColor}`,
        borderRadius: prop('borderRadius')(rules) || 0,
    };
    const visibility = get(region, 'data.visibility');
    return {
        cssClass: `${cssClass} ${getRegionMobileCssClass(rules, true, visibility)}`,
        html,
        fonts: region.data.fonts,
        align: textAlign(isRtl)(rules),
        color: prop('color')(rules) || defaultTextColor,
        fontFamily: prop('fontFamily')(rules),
        fontSize: prop('fontSize')(rules) || defaultTextSize,
        fontStyle: prop('fontStyle')(rules) || 'normal',
        textTransform: prop('textTransform')(rules) || 'none',
        outerPadding: getMargin(rules),
        innerPadding: getPadding(rules),
        textBackground: text,
        visibility,
    };
};
//# sourceMappingURL=get-text-section.js.map